export default __webpack_public_path__ + "media/5ad7f2ac1085aabfac8eac415d52a333dd385174a947a65ed1b2774dac6eb5c1.svg";